import { createSlice } from '@reduxjs/toolkit';
import * as _ from 'lodash';
import { ERROR_TYPES } from '../../utils/constantTypes';
import { createResetAction } from '../../utils';

interface utilsData {
  show: boolean;
  message: string;
  type: string;
}

const initialState: utilsData = {
  show: false,
  message: '',
  type: ''
};

const alertSlice = createSlice({
  name: 'Utils',
  initialState,
  reducers: {
    setShowAlert: (state, action) => {
      state.show = action.payload.show;
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
    resetUtils: createResetAction(initialState)
  }
});

export const { setShowAlert, resetUtils } = alertSlice.actions;

export default alertSlice.reducer;
